import { Component } from '@angular/core';

@Component({
  selector: 'app-project-welcome',
  standalone: true,
  imports: [],
  templateUrl: './project-welcome.component.html',
  styleUrl: './project-welcome.component.scss'
})
export class ProjectWelcomeComponent {

}
